(async function () {
  const cardsContainer = document.getElementById("pw-cards");
  const resultsCount = document.getElementById("pw-results-count");
  const searchInput = document.getElementById("pw-search-input");
  const dropdownBtn = document.getElementById("pw-dropdown-btn");
  const dropdownLabel = document.getElementById("pw-dropdown-label");
  const dropdownMenu = document.getElementById("pw-dropdown-menu");
  const dropdownArrow = document.getElementById("pw-dropdown-arrow");
  const clearYearsBtn = document.getElementById("pw-clear-years");
  const chipContainer = document.getElementById("pw-chip-container");
  const chipsWrapper = document.getElementById("pw-chips-wrapper");
  const clearAllBtn = document.getElementById("pw-clear-all");

  if (!cardsContainer) return;
  if (typeof pastWebinarsAssets === "undefined") return;

  // Assets
  const recordingBtnTpl = pastWebinarsAssets.recordingBtnTpl;
  const pdfBtnTpl = pastWebinarsAssets.pdfBtnTpl;
  const playIconUrl = pastWebinarsAssets.playIconUrl;
  const crossIconUrl = pastWebinarsAssets.crossIconUrl;

  function getRecordingBtn(url) {
    return recordingBtnTpl.replace("__RECORDING_URL__", url);
  }

  function getPdfBtn(url) {
    return pdfBtnTpl.replace("__PDF_URL__", url);
  }

  let pastWebinars = [];
  let selectedYears = [];
  let debounceTimer = null;
  let lastAPIResults = null;

  // Helpers
  function getThumbnailFromUrl(url) {
    if (!url) return "";
    const ytMatch = url.match(
      /(?:youtube(?:-nocookie)?\.com\/.*v=|youtu\.be\/)([^"&?/ ]{11})/i,
    );
    if (ytMatch)
      return `https://img.youtube.com/vi/${ytMatch[1]}/maxresdefault.jpg`;
    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
    if (vimeoMatch) return `https://vumbnail.com/${vimeoMatch[1]}.jpg`;
    return "";
  }

  function parseEndMs(doc) {
    if (doc.end_date_timestamp) return doc.end_date_timestamp * 1000;
    if (!doc.end_date) return null;
    const raw = doc.end_date;
    let d = null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) d = new Date(raw);
    else if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
      const [dd, mm, yyyy] = raw.split("/");
      d = new Date(`${yyyy}-${mm}-${dd}`);
    }
    return d && !isNaN(d) ? d.getTime() : null;
  }

  function getYear(doc) {
    const ms = parseEndMs(doc);
    return ms ? new Date(ms).getFullYear() : null;
  }

  function formatDisplayDate(raw) {
    if (!raw) return "";
    let d = null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) d = new Date(raw);
    else if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
      const [dd, mm, yyyy] = raw.split("/");
      d = new Date(`${yyyy}-${mm}-${dd}`);
    } else d = new Date(raw);
    if (!d || isNaN(d)) return raw;
    return d.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  // Initial fetch
  try {
    const now = Date.now();
    const filter_by = `choose_event_type:=[webinar-series] && end_date_timestamp:<=${Math.floor(now / 1000)}`;

    const url =
      `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/events/documents/search?` +
      new URLSearchParams({
        q: "*",
        query_by: "title,searchable_text,all_block_content",
        sort_by: "title:asc",
        per_page: 250,
        page: 1,
        filter_by,
        num_typos: 0,
        prefix: false,
      });

    const res = await fetch(url, {
      headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
    });
    const data = await res.json();
    const allDocs = data.hits?.map((hit) => hit.document) || [];

    pastWebinars = allDocs.filter((doc) => {
      if (!doc.choose_event_type?.includes("webinar-series")) return false;
      const endMs = parseEndMs(doc);
      return endMs && endMs < now;
    });

    buildYearDropdown();
    renderCards(pastWebinars);
  } catch (err) {
    console.error(err);
  }

  async function fetchFromAPI() {
    const keyword = searchInput.value.trim();
    const now = Date.now();

    let filter_by = `choose_event_type:=[webinar-series] && end_date_timestamp:<=${Math.floor(now / 1000)}`;

    if (selectedYears.length > 0) {
      const yearFilters = selectedYears
        .map(
          (year) =>
            `(end_date_timestamp:>=${Math.floor(new Date(year, 0, 1).getTime() / 1000)} && end_date_timestamp:<=${Math.floor(new Date(year, 11, 31, 23, 59, 59).getTime() / 1000)})`,
        )
        .join(" || ");
      filter_by += ` && (${yearFilters})`;
    }

    const url =
      `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/events/documents/search?` +
      new URLSearchParams({
        q: keyword || "*",
        query_by: "title,searchable_text,all_block_content",
        sort_by: "title:asc",
        per_page: 250,
        page: 1,
        filter_by,
        num_typos: 0,
        prefix: false,
      });

    try {
      const res = await fetch(url, {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });
      const data = await res.json();
      const docs = data.hits?.map((hit) => hit.document) || [];
      lastAPIResults = docs.filter((doc) => {
        const endMs = parseEndMs(doc);
        return endMs && endMs < Date.now();
      });
      applyFilters(true);
    } catch (e) {
      console.error(e);
      lastAPIResults = null;
      applyFilters();
    }
  }

  function debouncedAPIFetch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchFromAPI, 500);
  }

  // Build Year Dropdown
  function buildYearDropdown() {
    const years = [...new Set(pastWebinars.map(getYear).filter(Boolean))].sort(
      (a, b) => b - a,
    );

    dropdownMenu.innerHTML = years
      .map(
        (year) => `
      <li data-year="${year}" class="px-4 py-3 cursor-pointer hover:bg-brand-white-smoke text-brand-black text-[1.1rem] font-neutraface flex items-center gap-3">
        <input type="checkbox" id="year-${year}" class="w-4 h-4 accent-brand-dark-red">
        <label for="year-${year}" class="cursor-pointer flex-1">${year}</label>
      </li>
    `,
      )
      .join("");

    // Checkbox change handler
    dropdownMenu.querySelectorAll("li").forEach((li) => {
      const checkbox = li.querySelector("input[type='checkbox']");
      const year = parseInt(li.dataset.year);

      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          if (!selectedYears.includes(year)) selectedYears.push(year);
        } else {
          selectedYears = selectedYears.filter((y) => y !== year);
        }
        updateUI();
        debouncedAPIFetch();
      });
    });
  }

  // Central UI update function (this fixes your issue)
  function updateUI() {
    // Update dropdown label and clear button
    if (selectedYears.length === 0) {
      dropdownLabel.textContent = "Filter by Membership Year";
      clearYearsBtn.classList.add("hidden");
    } else {
      dropdownLabel.textContent = selectedYears
        .sort((a, b) => b - a)
        .join(", ");
      clearYearsBtn.classList.remove("hidden");
    }

    // Sync checkboxes with selectedYears array
    dropdownMenu
      .querySelectorAll("input[type='checkbox']")
      .forEach((checkbox) => {
        const year = parseInt(checkbox.id.replace("year-", ""));
        checkbox.checked = selectedYears.includes(year);
      });

    renderChips();
  }

  // Clear only years
  function clearSelectedYears() {
    selectedYears = [];
    updateUI();
  }

  // Clear Years × button
  clearYearsBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    clearSelectedYears();
    debouncedAPIFetch();
  });

  // Dropdown toggle
  function openDropdown() {
    dropdownMenu.classList.remove("hidden");
    dropdownArrow.style.transform = "rotate(180deg)";
  }
  function closeDropdown() {
    dropdownMenu.classList.add("hidden");
    dropdownArrow.style.transform = "rotate(0deg)";
  }

  dropdownBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdownMenu.classList.contains("hidden")
      ? openDropdown()
      : closeDropdown();
  });

  document.addEventListener("click", () => closeDropdown());

  // Search
  searchInput.addEventListener("input", () => {
    clearTimeout(debounceTimer);
    renderChips();
    debounceTimer = setTimeout(debouncedAPIFetch, 500);
  });

  // Clear All button - now fully synced
  clearAllBtn.addEventListener("click", (e) => {
    e.preventDefault();
    selectedYears = [];
    searchInput.value = "";
    lastAPIResults = null;
    updateUI(); // This updates dropdown + chips
    applyFilters();
  });

  // Render Chips
  function renderChips() {
    const chips = [];
    const keyword = searchInput.value.trim();

    selectedYears.forEach((year) =>
      chips.push({ label: year.toString(), type: "year" }),
    );
    if (keyword) chips.push({ label: keyword, type: "search" });

    if (chips.length > 0) {
      chipContainer.classList.remove("hidden");
      chipsWrapper.innerHTML = chips
        .map(
          (chip) => `
        <span data-chip-type="${chip.type}" data-value="${chip.label}"
              class="inline-flex items-center gap-2 pl-5 pr-2 py-2 rounded-full border border-brand-dark-red bg-brand-dark-red text-white text-p1 cursor-pointer">
          ${chip.label}
          <div class="w-[1.875rem] h-[1.875rem]">
            <img src="${crossIconUrl}" alt="close" class="w-full h-full">
          </div>
        </span>
      `,
        )
        .join("");

      chipsWrapper.querySelectorAll("span").forEach((chipEl) => {
        chipEl.addEventListener("click", () => {
          const type = chipEl.dataset.chipType;
          const value = chipEl.dataset.value;

          if (type === "year") {
            selectedYears = selectedYears.filter((y) => y !== parseInt(value));
          } else if (type === "search") {
            searchInput.value = "";
          }

          updateUI(); // Important: sync dropdown after chip remove
          if (selectedYears.length === 0 && !searchInput.value.trim()) {
            lastAPIResults = null;
            applyFilters();
          } else {
            debouncedAPIFetch();
          }
        });
      });
    } else {
      chipContainer.classList.add("hidden");
      chipsWrapper.innerHTML = "";
    }
  }

  // Apply filters
  function applyFilters(useAPI = false) {
    const keyword = searchInput.value.trim().toLowerCase();
    const hasKeyword = keyword.length > 0;
    const hasYears = selectedYears.length > 0;

    let source = useAPI && lastAPIResults ? lastAPIResults : pastWebinars;
    let filtered = source;

    if (!useAPI) {
      if (hasYears)
        filtered = filtered.filter((doc) =>
          selectedYears.includes(getYear(doc)),
        );
      if (hasKeyword) {
        filtered = filtered.filter((doc) => {
          const haystack = [
            doc.title,
            doc.event_description,
            doc.searchable_text,
          ]
            .join(" ")
            .toLowerCase();
          return haystack.includes(keyword);
        });
      }
    }

    if (hasKeyword || hasYears) {
      resultsCount.textContent = `${filtered.length} Result${filtered.length !== 1 ? "s" : ""}`;
      resultsCount.classList.remove("hidden");
    } else {
      resultsCount.classList.add("hidden");
    }

    renderCards(filtered);
  }

  // Card renderer (same as before)
  function renderCards(docs) {
    if (!docs.length) {
      cardsContainer.innerHTML =
        '<p class="text-center text-brand-black font-neutraface text-[1.25rem] font-normal w-full">No past webinars found.</p>';
      return;
    }

    cardsContainer.innerHTML = docs
      .map((doc) => {
        const hasRecording = !!doc.recording_link_url;
        const hasPdf = !!doc.slide_deck_pdf_url;
        const videoThumb = getThumbnailFromUrl(doc.recording_link_url);
        const thumbnail = videoThumb || doc.featured_image || "";
        const hasThumbnail = !!thumbnail;
        const showPlayIcon = !!videoThumb;

        const gridClass = hasThumbnail
          ? "w-full grid grid-cols-1 sm:grid-cols-[20rem_auto] pb-4 lg:pb-6 border-b border-brand-warm-beige"
          : "w-full grid grid-cols-1 pb-4 lg:pb-6 border-b border-brand-warm-beige";

        return `
        <div class="${gridClass}">
          ${
            hasThumbnail
              ? `
            <a href="${doc.recording_link_url}" class="w-full relative !h-auto max-sm:!max-h-[17rem] lg:!max-h-[17rem] sm:!h-full">
              <img src="${thumbnail}" alt="${doc.title || ""}" class="sm:absolute inset-0 w-full !h-full object-contain sm:object-cover object-center bg-brand-light-blue">
              ${showPlayIcon ? `<div class="absolute inset-0 flex items-center justify-center"><div class="w-[3.8rem] h-[3.8rem]"><img src="${playIconUrl}" alt="play" class="w-full h-full"></div></div>` : ""}
            </a>
          `
              : ""
          }

          <div class="w-full flex flex-col items-center sm:items-start justify-between gap-4 lg:gap-6 ${hasThumbnail ? "max-sm:pt-4 sm:pl-8 lg:pl-10 xl:pl-12" : "pt-0"}">
            <div class="w-full flex flex-col items-center gap-1 md:gap-2">
              ${doc.title ? `<h2 class="w-full text-[1.5625rem] leading-[2.0625rem] text-brand-dark-blue font-semibold text-center sm:text-start">${doc.title}</h2>` : ""}
              ${doc.event_description ? `<div class="w-full htmlBlock text-brand-black htmlBlock-para-style-after-sm">${doc.event_description}</div>` : ""}
              ${doc.end_date ? `<p class="w-full text-p1 text-brand-dark-red font-normal text-center sm:text-start">${formatDisplayDate(doc.end_date)}</p>` : ""}
            </div>

            ${
              hasRecording || hasPdf || doc.hosted_by_image
                ? `
              <div class="w-full flex flex-col lg:flex-row justify-center sm:justify-start lg:justify-between items-center sm:items-start lg:items-center gap-4 sm:gap-6">
                ${
                  hasRecording || hasPdf
                    ? `
                  <div class="w-full flex items-center justify-center sm:justify-start flex-wrap gap-2 sm:gap-3">
                    ${hasRecording ? getRecordingBtn(doc.recording_link_url) : ""}
                    ${hasPdf ? getPdfBtn(doc.slide_deck_pdf_url) : ""}
                  </div>
                `
                    : ""
                }
                ${
                  doc.hosted_by_image
                    ? `
                  <div class="w-max max-sm:mx-auto lg:h-full px-4 py-2 xsm:py-4 xsm:px-6 rounded-[.3125rem] bg-brand-blue-gray flex flex-col xsm:flex-row items-center justify-center sm:justify-between gap-2 xsm:gap-3 sm:gap-6 sm:flex-shrink-0">
                    <p class="text-p1 font-semibold text-brand-dark-blue">Hosted by</p>
                    <div class="w-full xsm:w-[.0625rem] h-[.0625rem] xsm:h-full bg-brand-light-sky-blue"></div>
                    <div class="w-[12.5rem] h-[4.375rem]"><img src="${doc.hosted_by_image}" alt="hosted by" class="w-full h-full object-contain object-center"></div>
                  </div>
                `
                    : ""
                }
              </div>
            `
                : ""
            }
          </div>
        </div>
      `;
      })
      .join("");
  }

  // Initial UI update
  updateUI();
})();
